import { http, HttpResponse } from 'msw';
const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/individual_organization_users`;

export const individualOrganizationUsersHandlers = [
  // 仮登録
  http.post(baseUrl, async ({ request }) => {
    const postRequest = (await request.json()) as {
      email: string;
      password: string;
      passwordConfirmation: string;
      'g-recaptcha-token': string;
    };
    console.info(postRequest);

    if (postRequest.email === 'error@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'email',
              message: 'メールアドレスを正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    }

    return HttpResponse.json({ success: true });
  }),
  // 本登録メール再送信
  http.post(`${baseUrl}/resend`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      email: string;
    };
    console.info(postRequest);

    if (postRequest.email === 'error@dummy.com') {
      return HttpResponse.json(
        { error_type: 'error', message: '確認メールの再送に失敗しました。' },
        { status: 400 }
      );
    }

    return HttpResponse.json({ success: true });
  }),
  // 退会
  http.delete(`${baseUrl}/withdraw`, async ({ request }) => {
    const postRequest = (await request.json()) as {
      motive: string;
    };
    console.info(postRequest);

    if (postRequest.motive === 'error') {
      return HttpResponse.json(
        { error_type: 'error', message: '入力エラーです。' },
        { status: 400 }
      );
    }

    return HttpResponse.json({ success: true });
  }),
];
